import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-linux-c3-series',
  templateUrl: './linux-c3-series.component.html',
  styleUrls: ['./linux-c3-series.component.css']
})
export class LinuxC3SeriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
